export default "__VITE_ASSET__BjiM$RVp__"